// generated from 37_610 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const hasPushByAppFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("has_push_by_app_filter"),
  comparison_key: z.literal("1"),
  display_name: z.object({
    // undefined: 37_595 (99.96%), defined 15 (0.04%)
    deleted_app: z.literal(true).optional(),
    id: common.objectId,
    value: z.string(),
  }),
  // undefined: 12_012 (31.94%), defined 25_598 (68.06%)
  // true 24_550 (95.91%), false 1_048 (4.09%)
  raw_value: z.boolean().optional(),
  // true 36_330 (96.60%), false 1_280 (3.40%)
  value: z.boolean(),
  varies_by_app_group: z.literal(false),
});
